import {PropsWithChildren} from "react";
import {Box, useMediaQuery} from "@mui/material";
import {Theme} from "@mui/system";
import {SMALL_SCREEN_BREAKPOINT} from "./ApplicationPage";

export function ApplicationSubPageContentContainer(props: PropsWithChildren<unknown>) {
  const smallScreens = useMediaQuery((theme: Theme) => theme.breakpoints.down(SMALL_SCREEN_BREAKPOINT));
  return (
    <Box sx={{
      height: "fit-content",
      borderColor: "gray",
      borderStyle: smallScreens ? "none" : "solid",
      borderWidth: 1,
      borderRadius: 2,
      padding: 3
    }}>
      {props.children}
    </Box>
  )
}
